import Verification from './verification';

export default Verification;